import { chat_history_item } from "@/shared/classes/chat_history_item";
import { chat_message } from "@/shared/classes/chat_message";



const STORAGE_KEY = "chat_history";

function readAll(): chat_history_item[] {
  try {
    var raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    var parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed;
    return [];
  } catch (e) {
    return [];
  }
}



function writeAll(list: chat_history_item[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch (e) {
    // opcional: logging
  }
}

function upsertThread(thread: chat_history_item): void {
  var list = readAll();
  var idx = -1;
  for (var i = 0; i < list.length; i++) {
    if (list[i].id === thread.id) {
      idx = i;
      break;
    }
  }
  thread.timestamp = Date.now();
  if (idx === -1) {
    list.push(thread);
  } else {
    list[idx] = thread;
  }
  writeAll(list);
}

function deleteThread(id: string): void {
  var list = readAll();
  var next = [];
  for (var i = 0; i < list.length; i++) {
    if (list[i].id !== id) next.push(list[i]);
  }
  writeAll(next);
}

function getThread(id: string): chat_history_item | null {
  var list = readAll();
  for (var i = 0; i < list.length; i++) {
    if (list[i].id === id) return list[i];
  }
  return null;
}

function listThreads(): chat_history_item[] {
  // más recientes primero
  var list = readAll();
  list.sort(function(a, b) {
    return b.timestamp - a.timestamp;
  });
  return list;
}

export const chat_history_service = {
  readAll,
  writeAll,
  upsertThread,
  deleteThread,
  getThread,
  listThreads,
};
